/* global Vue, VueI18n, LOYALTY_API, LOYALTY_INTERESTS, LOYALTY_PREFERENCES, DATA_LAYER */

import { setSuccessAndStopLoading, setErrorAndStopLoading, startLoading, stopLoading } from '../../apps/components/Notifications'
import InterestGroup from '../../apps/components/InterestGroup'
import { AuthService, fetchWithTokenAsync } from '../../AuthService'

export default {
  name: 'Interests',
  components: { InterestGroup },
  template: `
  <div class="loyalty-my-interests">
    <div class="container grid">
      <p class="large-text col-12 col-lg-10 offset-lg-1 col-xxl-8 offset-xxl-2">{{ $t('interestsTab.leadText') }}</p>
    </div>

    <div class="container grid no-padding-sm-down">
      <div class="col-12 col-lg-10 offset-lg-1 col-xxl-8 offset-xxl-2">
        <InterestGroup
          class="columns-2"
          :title="$t('interestsTab.holiday')"
          :items="LOYALTY_INTERESTS.filter(i => i.type === 'holiday')"
          :selectedItems="selectedItemsObj.holiday"
          @updateItems="$event => selectedItemsObj.holiday = $event">
        </InterestGroup>

        <div class="loyalty-my-interests__masonry">
          <InterestGroup
            v-for="type in types.filter(t => t !== 'holiday')"
            :title="$t('interestsTab.' + type)"
            :items="LOYALTY_INTERESTS.filter(i => i.type === type)"
            :selectedItems="selectedItemsObj[type]"
            @updateItems="$event => selectedItemsObj[type] = $event">
          </InterestGroup>
        </div>
      </div>
    </div>

    <div class="container grid">
      <div class="col-12 col-lg-10 offset-lg-1 col-xxl-8 offset-xxl-2 button-group">
        <button class="button button--outline" @click="$router.push('/')">{{ $t('cancel') }}</button>
        <button class="button button--maistar" @click="setInterests">{{ $t('confirm') }}</button>
      </div>
    </div>
  </div>
  `,
  props: {
    loyaltyId: Number,
  },
  setup (props, { emit }) {
    const { loyaltyId } = Vue.toRefs(props)
    const { t } = VueI18n.useI18n()
    const types = ['holiday', 'brand', 'destination', 'campsite']
    const preferenceTypes = ['bedding', 'rooms', 'services', 'food']

    const selectedItemsObj = Vue.reactive(
      types.reduce((obj, type) => {
        obj[type] = []
        return obj
      }, {}),
    )

    const selectedItemsArr = Vue.computed(() => Object.values(selectedItemsObj).flat())

    const setInterests = async () => {
      DATA_LAYER?.wwwSelectInterests({ allInterests: LOYALTY_INTERESTS, selectedInterestKeys: selectedItemsArr.value })

      try {
        startLoading('setInterests')
        const response = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/contacts/setInterests2`, AuthService.accessToken, 'PUT', {
          interests: selectedItemsArr.value,
        })
        if (response.status !== 0) {
          throw new Error('Set member interests failed.')
        }
        setSuccessAndStopLoading({ title: t('interestsTab.updateSuccess') })
      } catch (e) {
        setErrorAndStopLoading(e)
      }
    }

    Vue.watch(loyaltyId, async () => {
      try {
        startLoading('getInterests')
        const response = await fetchWithTokenAsync(`${LOYALTY_API}/api/v1/contacts/interests2`, AuthService.accessToken, 'GET')
        if (!response?.interests) {
          throw Error('getInterests')
        }

        [...types, ...preferenceTypes].forEach((type) => {
          selectedItemsObj[type] = [...LOYALTY_INTERESTS, ...LOYALTY_PREFERENCES].filter(i => response.interests.includes(i.key) && i.type === type).map(i => i.key)
        })

        stopLoading('getInterests')
      } catch (e) {
        console.error(e)
        emit('error', e)
      }
    }, { immediate: true })

    return {
      LOYALTY_INTERESTS,
      selectedItemsObj,
      types,
      setInterests,
    }
  },
}
